import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getEnqById } from '../../api/Api'; // Adjust the import path as necessary

const ViewEnq = () => {
  const { id } = useParams();
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStudent = async () => {
      try {
        const response = await getEnqById(id);
        if (response.success) {
          setStudent(response.data);
        } else {
          throw new Error("Failed to fetch student data");
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchStudent();
  }, [id]);

  if (loading) return <div className="text-[#16bab1]enter py-10 text-blue-500 font-medium">Loading student data...</div>;
  if (error) return <div className="text-[#16bab1]enter py-10 text-red-500 font-medium">Error: {error}</div>;

  return (
    <div className="max-w-4xl mt-8 mx-auto navbar-link px-6 py-8 bg-white rounded-xl shadow-lg">
      <h1 className="text-3xl font-bold text-indigo-700 mb-6 text-[#16bab1]enter">Student Enquiry Details</h1>

      {student ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-gray-700">
          <Detail label="Student Name" value={student.studentName} />
          <Detail label="Gender" value={student.gender || 'N/A'} />
          <Detail label="Date of Birth" value={student.dob ? new Date(student.dob).toLocaleDateString() : 'Invalid Date'} />
          <Detail label="Age" value={student.age || 'N/A'} />
          <Detail label="Enquiry For" value={student.admissionFor || 'N/A'} />

          <Detail label="Father's Name" value={student.fatherName || 'N/A'} />
          <Detail label="Father's Mobile" value={student.fatherMobile || 'N/A'} />
          <Detail label="Father's Email" value={student.fatherEmail || 'N/A'} />

          <Detail label="Mother's Name" value={student.motherName || 'N/A'} />
          <Detail label="Mother's Mobile" value={student.motherMobile || 'N/A'} />
          <Detail label="Mother's Email" value={student.motherEmail || 'N/A'} />

          <div className="md:col-span-2">
            <Detail
              label="Address"
              value={`${student.plotNo || ''}, ${student.street || ''}, ${student.landmark || ''}, ${student.area || ''}, ${student.city || ''}, ${student.state || ''}`}
            />
          </div>
        </div>
      ) : (
        <p className="text-[#16bab1]enter text-gray-500">No student data found.</p>
      )}
    </div>
  );
};

// Reusable detail block
const Detail = ({ label, value }) => (
  <div>
    <p className="text-sm font-semibold text-gray-500">{label}</p>
    <p className="text-base font-medium">{value}</p>
  </div>
);

export default ViewEnq;
